<div class="page">
    <div class="material">
        <div class="header">
            <app-button type="primary"
                        *ngIf="shouldRenderModifiers()"
                        (click)="openOperationTypesModal()">
                {{ 'admin.tickets.operation-types.buttons.createOperationTypes' | translate }}
            </app-button>
        </div>
        <div class="content">
            <app-operation-types-table [operationTypes]="operationTypes"
                                       [tableConfig]="tableConfig"
                                       [isLoading]="isLoadingOperationTypes"
                                       [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                       (sortChange)="onSortChange($event)"
                                       (filterChange)="onFilter($event)"
                                       (rowClick)="onTableRowClick($event)"
                                       (pageChange)="onPageChange($event)">
            </app-operation-types-table>
        </div>
    </div>
</div>
<app-operation-types-modal
    [isLoading]="isLoadingOperationTypes"
    (onCreate)="createOperationType($event)"
    (onUpdate)="updateOperationType($event)"
    (onDelete)="deleteOperationType($event)">
</app-operation-types-modal>
